export const timeout = (callback, duration = 4000) => {
  setTimeout(() => {
    callback();
  }, duration);
};
